import Trans from 'next-translate/Trans'
import { MarketingDrawer } from '@app/components/general/drawers/marketing-drawer'
import { Link } from '@app/components/stateless/typo/link'
import { metaSetter } from '@app/utils'
import {
  Header,
  Header2,
  Header3,
  Header4,
} from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { routeParseAbsolute } from '@app/lib/router-handler'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { blueLink } from '@app/components/stateless/typo/link-style'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/about',
    }),
  }
}

function About() {
  const { t, lang } = useTranslation('about')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <Header>{t('header')}</Header>
        <Paragraph>{t('header-details')}</Paragraph>
        <Header2>{t('sub-header')}</Header2>
        <Paragraph>{t('sub-details')}</Paragraph>
        <Header3>{t('goals')}</Header3>
        <Paragraph>{t('goals-details')}</Paragraph>
        <Header3>{t('cv')}</Header3>
        <Paragraph>{t('cv-details')}</Paragraph>
        <Header3>{t('speed')}</Header3>
        <Paragraph>{t('speed-details')}</Paragraph>
        <div className='py-2'>
          <Header4>{t('multiple')}</Header4>
          <Paragraph>{t('multiple-details')}</Paragraph>
        </div>

        <div className='pt-6'>
          <Trans
            i18nKey='about:consultants'
            components={[
              <Paragraph key={'consul-1'} />,
              <Link
                className={blueLink}
                href={routeParseAbsolute(`/consulting`, lang)}
                key={'consul-2'}
              />,
            ]}
          />
        </div>
        <p className='font-bold py-4 text-sm'>{t('founded')}</p>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { About },
  {
    translation: 'about',
  }
)
